'use client';

import { clsx } from 'clsx';

import { useParamsUpdater } from '@monoimin/hooks';

import {
  defineOrderSortParam,
  getOrderSortActivity,
  getPlainSortActivity,
} from '../utils/sorting';

import { OrderSortIcon } from './OrderSortIcon';

import type { EnOrRuLocale } from '@monoimin/sb-types';

import type {
  SortConfigs,
  PlainSortConfig,
  OrderSortConfig,
  FiltersState,
} from '../types';

type SortingProps = {
  configs: SortConfigs;
  locale: EnOrRuLocale;
  newPathname?: string;
  additionalFilterParams?: FiltersState;
  defaultSortParam?: string;
};

export const Sorting = ({
  configs,
  locale,
  newPathname,
  additionalFilterParams = {},
  defaultSortParam = '',
}: SortingProps) => {
  const { searchParams, onChange: onParamsChange } = useParamsUpdater();

  const sortParam = searchParams?.get(`sort`) || defaultSortParam;

  const onSortingChange = (config: PlainSortConfig | OrderSortConfig) => {
    const { sortKey, type } = config;

    const newParams = {
      ...additionalFilterParams,
      sort:
        type === 'plain' ? sortKey : defineOrderSortParam(sortParam, sortKey),
    };

    onParamsChange(newParams, newPathname);
  };

  return (
    <div className='flex flex-wrap text-lg lg:text-xl gap-x-5 lg:gap-x-9'>
      {configs.map((item) => {
        const isPlain = item.type === 'plain';

        const isOrder = item.type === 'order';

        const activity = isPlain
          ? getPlainSortActivity(sortParam, item.sortKey)
          : getOrderSortActivity(sortParam, item.sortKey);

        return (
          <button
            disabled={isPlain ? Boolean(activity) : false}
            key={item.titles[locale]}
            onClick={() => onSortingChange(item)}
            className={clsx('sorting-button button', item.className, {
              'font-bold': activity,
              'flex items-center gap-2': isOrder,
            })}
          >
            <span>{item.titles[locale]}</span>
            {isOrder && typeof activity !== 'boolean' && (
              <OrderSortIcon activity={activity} />
            )}
          </button>
        );
      })}
    </div>
  );
};
